<template>
  <div class="bxKb" v-if="kbxmlc">
    <div class="box noBtn">
      <div class="clear">
        <p class="cont-title lf">有效性审查</p>
        <div class="rt">
          <el-input
            v-model="tbdwmc"
            class="input-with-select rt"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getData"
            ></el-button>
          </el-input>
          <el-button class="rt" type="primary" @click="lookJjgg"> 查看竞价公告 </el-button>
        </div>
        <table-tem
          :config="tableConfig"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
          <template #sczt="scope">
            <!-- <div>{{scope}}</div> -->
            <el-select
              v-model="scope.data.sczt"
              v-if="!isNext && role == 'Z'"
              class="small"
              @change="changeSczt(scope.data)"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
            <template v-else>{{
              scope.data.sczt == "1"
                ? "通过"
                : scope.data.sczt == "2"
                ? "不通过"
                : ""
            }}</template>
          </template>
        </table-tem>
        <span class="lf pageNum"
          >此次共有{{ zgs }}家投标单位，递交投标报价{{ bjgs }}家</span
        >
      </div>
      <el-button
      v-if="!isNext && role == 'Z'"
        :disabled="isNext"
        @click="bxNextBtn"
        type="primary lcNext"
        >下一步</el-button
      >
    </div>
    <el-dialog
      title="备注"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-input v-model="scztData.remark"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>

<script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  components: {
    tableTem,
  },
  computed: {
    role() {
      return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
    },
    isNext() {
      return this.kbxmlc.zt == 2;
    },
  },
  data() {
    return {
      tbdwmc: "", //查询条件
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "fcqymc",
            title: "投标单位名称",
            align: "center",
          },
          {
            key: "bzjjnqk",
            title: "保证金缴纳情况",
            align: "center",
            codeMateVal: {
              0: "未缴纳",
              1: "已缴纳",
              3: "无需缴纳",
            },
          },
          {
            key: "fcsfbj",
            title: "是否报价",
            align: "center",
            showTool: true,
            codeMateVal: {
              0: "未报价",
              1: "已报价",
            },
          },
          {
            key: "sczt",
            title: "审查结果",
            align: "center",
            type: "slot",
            slotName: "sczt",
            codeMateVal: {
              0: "未审查",
              1: "通过",
              2: "不通过",
            },
          },
          {
            key: "remark",
            title: "备注",
            align: "center",
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
      },
      bjgs: 0,
      zgs: 0,
      kbxmlc: {},
      options: [
        { label: "通过", id: "1" },
        { label: "不通过", id: "2" },
      ],
      scztData: {},
      dialogVisible: false,
      kbxm: "",
    };
  },
  created() {
    this.djlcId = this.$route.query.djlcId;
    this.getIsShowBail();
    this.getData();
  },
  methods: {
    async getIsShowBail() {
      const res = await this.$api.getIsShowDeposit();
      // 如果res.data.data是false，去除tableConfig.head中key为bzjjnqk的对象
      if (!res.data.data) {
        this.tableConfig.head = this.tableConfig.head.filter((item) => {
          return item.key !== "bzjjnqk";
        });
      }
    },
    async lookJjgg() {
      const res = await this.$api.noticeView();
      let blob = new Blob([res.data],{
        type: "application/pdf"
      });
      let url = window.URL.createObjectURL(blob)
      window.open(url,"_blank")
    },
    async submitRemark() {
      if (!this.scztData.remark || this.scztData.remark == "") {
        this.$message({
          type: "warning",
          message: "请填写备注",
        });
        
      } else {
        let para = [
          {
            bdId: this.kbxm.fgbdid,
            kbsczt: this.scztData.sczt,
            scyj: this.scztData.remark,
            qyjgdm: this.scztData.fcqyjgdm,
          },
        ];
        try {
          const res = await this.$api.updateEntInfo(para);
          this.dialogVisible = false;
        } catch (error) {
          console.log(error);
        }
        
      }
    },
    async changeSczt(row) {
      this.scztData = row;
      if (this.scztData.sczt == "2") {
        this.dialogVisible = true;
      } else {
        let para = [
          {
            bdId: this.kbxm.fgbdid,
            kbsczt: row.sczt,
            scyj: row.remark,
            qyjgdm: row.fcqyjgdm,
          },
        ];
        try {
          const res = await this.$api.updateEntInfo(para);
        } catch (error) {
          console.log(error);
        }
      }
    },
    getData() {
      let para = {
        djlcId: this.djlcId,
        tbdwmc: this.tbdwmc,
        currentPage: this.tableConfig.currentPage,
        pageSize: this.tableConfig.pageSize,
        isCb: 0,
      };
      this.waitLoading = true;
      this.$api
        .kblbList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableConfig.data = res.data.data.tbdwList;
            this.tableConfig.total = res.data.data.total;
            this.bjgs = res.data.data.bjgs;
            this.zgs = res.data.data.zgs;
            this.kbxmlc = res.data.data.kbxmlc;
            this.kbxm = res.data.data.kbxm;
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    async bxNextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("bxNextBtn", para);
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.pageNum {
  // position: relative;
  // bottom: 50px;
  line-height: normal;
}
</style>
